
export default function PRReportPackageConfigurationReportController(
  $scope,
  $rootScope,
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  loaderService,
  selectReportParametersDialog,
  selectAdvisoryReportParametersDialog,
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasParameters = false;

  vm.handleExpand = _handleExpand;
  vm.handleEditReportParameters = _handleEditReportParameters;
  vm.handleRemoveReport = _handleRemoveReport;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  _activate();

  _initEventListeners();

  /** ********************************************
   * Private Functions
   */

  function _activate() {}

  function _initEventListeners() {
    $scope.$on('refreshReportPackageSummaryParameters', (event, opt) => {
      if ((Number(opt.reportPackageId) === Number(vm.reportPackageId)) && (opt.reportGroupIds.includes(vm.reportPackageConfigurationReport.reportGroupId))) {
        _refreshReportParameters();
        _refreshReportRenderTypes();
      }
    });
  }

  /** ********************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (!vm.isExpanded) {
      loaderService.showViewLoader = true;
      _refreshReportParameters()
      .then((response) => {        
        vm.isExpanded = !vm.isExpanded;
      }).catch(() => {
        alerts.error('An error occurred while getting the parameters for the report.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
    } else {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleEditReportParameters($event) {
    if (vm.reportPackageConfigurationReport.reportTypeId === 2) {
      ssDialogService.dialogs.reports.selectReportParametersDialog = ssDialogService.alert(
        selectReportParametersDialog.getOptions($event, {
          reportPackageId: vm.reportPackageId,
          reportPackageConfiguration: vm.reportPackageConfigurationReport,
          editMode: 2,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.reports.selectReportParametersDialog);
    } else {
      ssDialogService.dialogs.reports.selectAdvisoryReportParametersDialog = ssDialogService.alert(
        selectAdvisoryReportParametersDialog.getOptions($event, {
          reportPackageId: vm.reportPackageId,
          reportPackageConfiguration: vm.reportPackageConfigurationReport,
          editMode: 2,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.reports.selectAdvisoryReportParametersDialog);
    }
  }

  function _handleRemoveReport($event) {
    ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Report?',
        message:
          `Are you sure you want to remove "${vm.reportPackageConfigurationReport.reportName}" from the package?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;

    if (vm.reportPackageConfigurationReport.reportTypeId === 1) {
      return reportsDataService.deleteReportPackageReportInstance(vm.reportPackageConfigurationReport.reportPackageReportId)
        .then(() => {
          alerts.success('The report has been successfully removed from the Package.');
          $rootScope.$broadcast('refreshReportPackageConfiguration', { reportPackageId: Number(vm.reportPackageId) });
          $rootScope.$broadcast('refreshReportPackageSummary', { reportPackageId: Number(vm.reportPackageId) });   
          _closeDeleteDialog();
        }).catch(() => {
          alerts.error('An error occurred while deleting the schedule.');
        }).finally(() => {
          loaderService.showViewLoader = false;
        });
    } else {
      return reportsDataService.deleteReportPackageReportParameter(vm.reportPackageConfigurationReport.reportPackageReportId)
        .then(() => {
          alerts.success('The report has been successfully removed from the Package.');
          $rootScope.$broadcast('refreshReportPackageConfiguration', { reportPackageId: Number(vm.reportPackageId) });
          $rootScope.$broadcast('refreshReportPackageSummary', { reportPackageId: Number(vm.reportPackageId) });   
          _closeDeleteDialog();
        }).catch(() => {
          alerts.error('An error occurred while deleting the schedule.');
        }).finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog);
  }

  function _refreshReportParameters() {
    const reportPackageId = vm.reportPackageId;
    const reportId = vm.reportPackageConfigurationReport.reportId;
    return reportsDataService.getReportParameterReportTypesByReportPackageAndReport(reportPackageId, reportId).then((response) => {
      vm.reportPackageConfigurationReport.parameters = response.data.result;
      if (vm.reportPackageConfigurationReport.parameters.length > 0) {
        vm.hasParameters = true;

        vm.reportPackageConfigurationReport.allParametersHaveSubmittedParameters = false;
        vm.reportPackageConfigurationReport.savedParameterCount = 0;

        angular.forEach(vm.reportPackageConfigurationReport.parameters, (parameter) => {
          if (parameter.parameterHasValue) {
            vm.reportPackageConfigurationReport.savedParameterCount = vm.reportPackageConfigurationReport.savedParameterCount + 1;
          }
        });

        if (vm.reportPackageConfigurationReport.savedParameterCount == vm.reportPackageConfigurationReport.parameters.length) {
          vm.reportPackageConfigurationReport.allParametersHaveSubmittedParameters = true;
        }
      }
    });
  }

  function _refreshReportRenderTypes() {
    const reportPackageReportParameterId = vm.reportPackageConfigurationReport.reportPackageReportId;
    return reportsDataService.getReportPackageParameter(reportPackageReportParameterId).then((response) => {
      vm.reportPackageConfigurationReport.renderFormat = response.data.renderFormat;
    });
  }
}

PRReportPackageConfigurationReportController.$inject = [
  '$scope',
  '$rootScope',
  'ssDialogService',
  'alerts',
  'confirmDialog',
  'reportsDataService',
  'loaderService',
  'selectReportParametersDialog',
  'selectAdvisoryReportParametersDialog',
];
